var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "quantity-unit-input"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-grow-1",
    staticStyle: {
      "min-width": "120px"
    }
  }, [_c('v-text-field', {
    key: _vm.inputKey,
    ref: "input",
    staticClass: "quantity-unit-input__field",
    attrs: {
      "autofocus": _vm.autofocus,
      "disabled": _vm.disabled,
      "error-messages": _vm.errorMessages,
      "filled": _vm.filled,
      "label": _vm.label,
      "outlined": _vm.outlined,
      "placeholder": _vm.placeholder,
      "prepend-inner-icon": _vm.prependInnerIcon,
      "required": _vm.required,
      "suffix": _vm.displayedUnitSuffix,
      "value": _vm.displayQuantity,
      "dense": "",
      "hide-details": "auto",
      "type": "text",
      "inputmode": _vm.allowNegative ? 'text' : 'decimal',
      "autocomplete": "off"
    },
    on: {
      "input": _vm.updateQuantity,
      "blur": _vm.onBlur,
      "keydown": function keydown($event) {
        return _vm.$emit('keydown', $event);
      }
    },
    scopedSlots: _vm._u([_vm.$scopedSlots.label ? {
      key: "label",
      fn: function fn() {
        return [_vm._t("label")];
      },
      proxy: true
    } : null], null, true)
  })], 1), _vm.shouldShowUnitSelector ? _c('div', {
    staticClass: "flex-grow-0 ml-2 quantity-unit-input__unit",
    style: _vm.unitSelectorStyle
  }, [_vm.hasFormatUnitOptions ? _c('QuantityUnitSelect', {
    staticClass: "quantity-unit-input__unit-select",
    attrs: {
      "disabled": _vm.disabled,
      "filled": _vm.filled,
      "outlined": _vm.outlined,
      "options": _vm.unitOptions,
      "value": _vm.selectedUnit
    },
    on: {
      "input": _vm.updateUnit,
      "keydown": function keydown($event) {
        return _vm.$emit('keydown', $event);
      }
    }
  }) : _c('v-select', {
    staticClass: "quantity-unit-input__unit-select",
    attrs: {
      "disabled": _vm.disabled,
      "filled": _vm.filled,
      "items": _vm.unitOptions,
      "outlined": _vm.outlined,
      "value": _vm.selectedUnit,
      "menu-props": {
        maxWidth: _vm.unitSelectorMenuWidth
      },
      "item-text": "text",
      "item-value": "value",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.updateUnit,
      "keydown": function keydown($event) {
        return _vm.$emit('keydown', $event);
      }
    }
  })], 1) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }